import { render, staticRenderFns } from "./ApplicantDocument.vue?vue&type=template&id=3c9e9f46&scoped=true&"
import script from "./ApplicantDocument.vue?vue&type=script&lang=js&"
export * from "./ApplicantDocument.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantDocument.vue?vue&type=style&index=0&id=3c9e9f46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9e9f46",
  null
  
)

export default component.exports